const IPV4_RE = /^(\d{1,3}\.){3}\d{1,3}$/;

export function getTenantIdFromHostname(hostname: string): string | null {
  const host = (hostname || '').toLowerCase().trim();
  if (!host || host === 'localhost' || host === '127.0.0.1') {
    return null;
  }
  if (IPV4_RE.test(host)) {
    return null;
  }
  if (host.endsWith('.localhost')) {
    const tenant = host.slice(0, host.length - '.localhost'.length);
    return tenant || null;
  }
  const parts = host.split('.');
  if (parts.length >= 2) {
    return parts[0] || null;
  }
  return null;
}
